module.exports = __webpack_public_path__ + "img/refund4.da2fd82c.png";